import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TextControl } from '@shared/ui/controls/text-control.model';
import { BenchTemplateItem } from '../../../shared/interfaces/entities/bench-template-item.interface';
import { BenchTemplateService } from '../services/bench-template.service';
import { AvailableItemsSelect } from '../../../shared/ui/select-controls/available-items-select.model';
import { AvailableItemFilter } from '../../../shared/interfaces/select-filters/available-item.filter.interface';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { AuthenticationService } from '../../../core/services/authentication.serivce';

@Component({
  selector: 'app-bench-template-add-item',
  standalone: false,
  templateUrl: './bench-template-add-item.component.html',
  styleUrls: ['./bench-template-add-item.component.css']
})
export class BenchTemplateAddItemComponent implements OnInit {

  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  public submitted: boolean = false;
  saving: boolean = false;
  saveIcon = faSave;

  id: number;
  public form: FormGroup;

  availableItems: AvailableItemsSelect;

  constructor(private fb: FormBuilder, private auth: AuthenticationService) { }

  ngOnInit() {
    this.availableItems = new AvailableItemsSelect("Test", "", new Array<any>);

    var organizationId: AvailableItemFilter = {
      OrganizationId: this.auth.getOrganizationId()
    };
    this.availableItems.filters = organizationId;

    this.form = this.fb.group({
      id: this.id,
      availableItems: null,
    });
  }

  save() {
    this.submitted = true;
    this.saving = true;

    var availableItems = this.availableItems.value?.map(x => x.id);

    this.form.controls['availableItems'].setValue(availableItems);

    this.submitForm.emit(this.form);
  }

}
